import React from 'react';
import { formatFleetMetricDays } from '../../../utils/fleetMetricUtils';
import './ComplaintPerformanceMetricsCards.css';

/**
 * Four-card complaint performance grid (engine-aligned: ack/closure TAT, MTTR, MTBF).
 * Observation window is last 12 months — not the Complaints list 30-day default.
 * @param {{ observation_window?, ack_tat?, closure_tat?, mttr?, mtbf? }} metrics
 */
function ComplaintPerformanceMetricsCards({ metrics }) {
  if (!metrics) {
    return null;
  }

  const windowLabel = metrics.observation_window?.label || 'Last 12 months';

  return (
    <div className="complaint-metric-cards">
      <div className="list-default-window-note" role="note">
        <span className="list-default-window-note__icon" aria-hidden="true">ℹ️</span>
        <span>
          Showing metrics from the <strong>{windowLabel}</strong>.
          Acknowledgement and closure TAT are report → ack and report → close;
          restore time and MTBF match Device View (impacting, breakdown-based).
        </span>
      </div>
      <div className="complaint-metric-grid">
        <div className="complaint-metric-card">
          <div className="complaint-metric-card__label">Acknowledgement TAT</div>
          <div className="complaint-metric-card__value">{formatFleetMetricDays(metrics.ack_tat)}</div>
          <div className="complaint-metric-card__count">{metrics.ack_tat?.count || 0} acknowledged</div>
          <div className="complaint-metric-card__hint">Report to acknowledge</div>
        </div>
        <div className="complaint-metric-card">
          <div className="complaint-metric-card__label">Closure TAT</div>
          <div className="complaint-metric-card__value">{formatFleetMetricDays(metrics.closure_tat)}</div>
          <div className="complaint-metric-card__count">{metrics.closure_tat?.count || 0} closed</div>
          <div className="complaint-metric-card__hint">Report to close</div>
        </div>
        <div className="complaint-metric-card">
          <div className="complaint-metric-card__label">Avg restore (12 mo)</div>
          <div className="complaint-metric-card__value">{formatFleetMetricDays(metrics.mttr)}</div>
          <div className="complaint-metric-card__count">{metrics.mttr?.count || 0} impacting closures</div>
          <div className="complaint-metric-card__hint">Breakdown to close (MTTR)</div>
        </div>
        <div className="complaint-metric-card">
          <div className="complaint-metric-card__label">MTBF (12 mo)</div>
          <div className="complaint-metric-card__value">{formatFleetMetricDays(metrics.mtbf)}</div>
          <div className="complaint-metric-card__count">{metrics.mtbf?.count || 0} devices</div>
          <div className="complaint-metric-card__hint">Between impacting failures</div>
        </div>
      </div>
    </div>
  );
}

export default ComplaintPerformanceMetricsCards;
